import Button from './ui/Button';
import InfoPanel from './ui/InfoPanel';
import Popup from './ui/Popup';
import { ReactComponent as CheckIcon } from '../assets/icons/check.svg';
import { ReactComponent as MailIcon } from '../assets/icons/mail.svg';
import { ReactComponent as PersonIcon } from '../assets/icons/person.svg';
import locales from '../locales.json';

const { DONE_TEXTS, COMMON_TEXTS } = locales;

const ICONS = {
  mail: MailIcon,
  user: PersonIcon,
};

const RegistrationDone = ({ onClose }) => (
  <Popup titleId="done-title" icon={CheckIcon} tone="ok">
    <h1 className="sheet__title" id="done-title">
      {DONE_TEXTS.title}
    </h1>
    <p className="sheet__body">{DONE_TEXTS.body}</p>

    <InfoPanel className="pop__info">
      <h3 className="info__title">{DONE_TEXTS.infoTitle}</h3>
      <ul className="mails">
        {DONE_TEXTS.mails.map((mail) => {
          const MailTypeIcon = ICONS[mail.icon];

          return (
            <li key={mail.title} className="mails__item">
              <span className="mails__icon">
                <MailTypeIcon aria-hidden="true" />
              </span>
              <span>
                <b className="mails__title">{mail.title}</b>
                <small className="mails__text">{mail.text}</small>
              </span>
            </li>
          );
        })}
      </ul>
    </InfoPanel>

    <div className="pop__actions">
      <Button variant="ghost" block onClick={onClose}>
        {COMMON_TEXTS.close}
      </Button>
    </div>
  </Popup>
);

export default RegistrationDone;
